import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import BookButton from "./BookButton";
import { site } from "@/content";

export default function MobileBookingBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-booking-bar"
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-30 border-t border-line bg-cream/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md transition-[transform,opacity] duration-300 md:hidden ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-full opacity-0"
      }`}
    >
      <div className="flex items-center gap-3">
        <a
          href={site.phone.href}
          tabIndex={visible ? 0 : -1}
          aria-label={`Ring ${site.phone.display}`}
          data-testid="mobile-bar-phone-link"
          className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-line text-forest"
        >
          <Phone className="h-5 w-5" />
        </a>
        <BookButton testId="mobile-bar-book-button" className="flex-1" />
      </div>
    </div>
  );
}
